import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://6e8ba4841f455a9364c02219c1764dd2@o1400866.ingest.us.sentry.io/4511440595779584',
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost'],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});
